module.exports = __webpack_public_path__ + "img/photo-green.1008d248.png";